import type { FC } from "react";
import { Link } from "react-router-dom";

import { AppStrings } from "../../../utils/constants/AppStrings";
import {
  REGULATOR_PORTAL_REPORTS_ROUTE,
  REGULATOR_PORTAL_RESULTS_ROUTE,
  REGULATOR_PORTAL_RULES_ROUTE,
  REGULATOR_PORTAL_SERVICES_ROUTE,
} from "../regulatorPortalRoutes";

import screenStyles from "../RegulatorPortalScreen.module.css";
import styles from "../Compliance/Compliance.module.css";

/**
 * Landing page for an approved regulator. Results, rules, services, and reports
 * are the surfaces the portal exposes for this jurisdiction.
 */
const RegulatorPortalDashboard: FC = () => (
  <section className={styles.page} data-testid="regulator-portal-dashboard">
    <h1 className={screenStyles.panelTitle}>
      {AppStrings.PAM_REGULATOR_PORTAL_DASHBOARD_TITLE}
    </h1>
    <div className={styles.dashboardGrid}>
      <Link
        to={REGULATOR_PORTAL_RESULTS_ROUTE}
        className={styles.dashboardCard}
        data-testid="regulator-portal-dashboard-results"
      >
        <h2 className={styles.dashboardCardTitle}>
          {AppStrings.PAM_REGULATOR_PORTAL_RESULTS}
        </h2>
        <p className={styles.dashboardCardBody}>
          {AppStrings.PAM_REGULATOR_PORTAL_DASHBOARD_RESULTS}
        </p>
      </Link>
      <Link
        to={REGULATOR_PORTAL_RULES_ROUTE}
        className={styles.dashboardCard}
        data-testid="regulator-portal-dashboard-rules"
      >
        <h2 className={styles.dashboardCardTitle}>
          {AppStrings.PAM_REGULATOR_PORTAL_RULES}
        </h2>
        <p className={styles.dashboardCardBody}>
          {AppStrings.PAM_REGULATOR_PORTAL_DASHBOARD_RULES}
        </p>
      </Link>
      <Link
        to={REGULATOR_PORTAL_SERVICES_ROUTE}
        className={styles.dashboardCard}
        data-testid="regulator-portal-dashboard-services"
      >
        <h2 className={styles.dashboardCardTitle}>
          {AppStrings.PAM_REGULATOR_PORTAL_SERVICES}
        </h2>
        <p className={styles.dashboardCardBody}>
          {AppStrings.PAM_REGULATOR_PORTAL_DASHBOARD_SERVICES}
        </p>
      </Link>
      <Link
        to={REGULATOR_PORTAL_REPORTS_ROUTE}
        className={styles.dashboardCard}
        data-testid="regulator-portal-dashboard-reports"
      >
        <h2 className={styles.dashboardCardTitle}>
          {AppStrings.PAM_REGULATOR_PORTAL_REPORTS}
        </h2>
        <p className={styles.dashboardCardBody}>
          {AppStrings.PAM_REGULATOR_PORTAL_DASHBOARD_REPORTS}
        </p>
      </Link>
    </div>
  </section>
);

export default RegulatorPortalDashboard;
